import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessingRoutingModule } from './processing-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AdminRoutingModule } from '../admin/admin-routing.module';
import { SharedModule } from '../../shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule } from '@angular/material/sort';
import { MaterialModule } from '../../core/material/material.module';
import { PlatformActivityComponent } from './platform-activity/platform-activity.component';
import { AllStepsTableComponent } from './platform-activity/all-steps-table/all-steps-table.component';
import { ActiveStepsTableComponent } from './platform-activity/active-steps-table/active-steps-table.component';
import { ProcessingDetailsPaneComponent } from './platform-activity/processing-details-pane/processing-details-pane.component';
import { SnapshotTableComponent } from './platform-activity/snapshot/snapshot-table.component';
import { MatSliderModule } from '@angular/material/slider';
import { IndexHealthTableComponent } from './platform-activity/index-health-table/index-health-table.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ServersTableComponent } from './platform-activity/servers-table/servers-table.component';
import { ServicesTableComponent } from './platform-activity/services-table/services-table.component';
import { ActiveWorkflowsTableComponent } from "./platform-activity/active-workflows-table/active-workflows-table.component";
import { DateAgoPipe } from "../../pipes/date-ago.pipe";
import { CustomButtonComponent } from "../common/icon-button/icon-button.component";
import { FriendlyBytesPipe } from "../../pipes/bytes.pipe";
import { CasePrioritiesComponent } from "./platform-activity/panels/case-priorities/case-priorities.component";

@NgModule({
	declarations: [
		PlatformActivityComponent,
		AllStepsTableComponent,
		ActiveStepsTableComponent,
		ProcessingDetailsPaneComponent,
		SnapshotTableComponent,
		IndexHealthTableComponent,
		ServersTableComponent,
		ServicesTableComponent,
		ActiveWorkflowsTableComponent,
		CasePrioritiesComponent
	],
	imports: [
		CommonModule,
		ProcessingRoutingModule,
		ReactiveFormsModule,
		MaterialModule,
		AdminRoutingModule,
		SharedModule,
		MatInputModule,
		MatFormFieldModule,
		MatSortModule,
		MatSliderModule,
		ClipboardModule,
		DateAgoPipe,
		CustomButtonComponent,
		FriendlyBytesPipe,
	]
})
export class ProcessingModule {
}
